// Keep reusable Facility aliases in the source mapping.
export function copyFacilityAliases(entries) {
  return (Array.isArray(entries) ? entries : []).map(entry => ({
    sourceValue: entry.sourceValue,
    facilityId: entry.facilityId,
  }));
}

export function buildRegisterImportRequest(input) {
  const mapping = input.mapping || {};
  return {
    registerId: input.registerId,
    data: input.data,
    fileName: input.fileName,
    mapping: {
      fieldMappings: mapping.fieldMappings || {},
      fieldTypes: mapping.fieldTypes || {},
      mandatoryFields: mapping.mandatoryFields || {},
      tagColumn: mapping.tagColumn,
      facilityColumn: mapping.facilityColumn,
      identityColumn: mapping.identityColumn,
      facilityValueMappings: copyFacilityAliases(mapping.facilityValueMappings),
    },
  };
}

export function registerReadContext({ viewContext, facilityId, hasFacilityProp, routeFacilityId }) {
  const effectiveId = viewContext === 'central' ? null : (hasFacilityProp ? facilityId : routeFacilityId);
  return { viewContext: viewContext || (effectiveId ? 'member' : 'central'), facilityId: effectiveId || null };
}

export function facilityAliasErrors(entries, members) {
  const seen = new Set();
  const memberIds = new Set(members.map(member => member.id));
  const errors = [];
  entries.forEach((entry, index) => {
    const key = String(entry.sourceValue || '').trim().toLowerCase();
    if (!key) errors.push(`Alias ${index + 1}: enter a source value.`);
    else if (seen.has(key)) errors.push(`Alias ${index + 1}: duplicate source value.`);
    seen.add(key);
    if (!memberIds.has(entry.facilityId)) errors.push(`Alias ${index + 1}: select a current member Facility.`);
  });
  return errors;
}

export function normalizeImportResult(result = {}) {
  return {
    ...result,
    errors: (result.errors || result.warnings || []).map(row => ({
      ...row,
      validationErrors: row.validationErrors || row.errors || [],
    })),
  };
}

export function executionWarningText(execution) {
  const warnings = execution.warnings || [];
  const counts = [];
  if (execution.recordsSkipped) counts.push(`${execution.recordsSkipped} skipped`);
  if (execution.facilityGroupLevelRows) counts.push(`${execution.facilityGroupLevelRows} saved at Facility Group level`);
  const details = warnings.length ? warnings.map(row => `Row ${row.rowIndex}${row.wasSkipped ? ' (skipped)' : ''}: ${(row.errors || row.validationErrors || []).join('; ')}`) : [execution.errorDetails || ''];
  return [...counts, ...details].filter(Boolean).join('\n');
}
